import Bugsnag from '@bugsnag/js'
import { Add, InsertDriveFile } from '@mui/icons-material'
import { Box, Typography, Skeleton, Card, Icon } from '@mui/material'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { getCustomCategory } from 'services/api/modules/payroll/payroll-config/customCategoryApi'
import {
  retrieveExcludedEmployees,
  retrieveIncludedEmployees,
} from 'services/api/modules/payroll/payroll-config/excludeEmployeeApi'
import { getNumDays } from 'services/api/modules/payroll/payroll-config/generalApi'
import { getOvertimeRate } from 'services/api/modules/payroll/payroll-config/overtimeConfigApi'
import CustomCategoryTabPanel from '../components/CustomCategoryTabPanel'
import ExcludedEmployeeList from '../components/ExcludedEmployeeList'
import ExcludedEmployeeModal from '../components/ExcludedEmployeeModal'
import { OvertimeList } from '../components/OvertimeList'
import OvertimeRateModal from '../components/OvertimeRateModal'
import PayslipThemeSetting from '../components/PayslipThemeSetting'
import ConnectedModules from '../components/ConnectedModules'
import ReminderModal from '../components/ReminderModal'
import AdxButton from 'components/custom/AdxButton'

const PayrollConfiguration = () => {
  const location = useLocation()
  const navigate = useNavigate()

  //custom category api
  const { isLoading: loadCustomCategory, data: customCategory } = useQuery(
    'getCustomCategory',
    async () => {
      const { data } = await getCustomCategory()
      let overtimeData = data?.data?.categories
      return overtimeData
    },
    {
      onError: (err) => Bugsnag.notify(err),
    }
  )

  //overtime api
  const { isLoading: loadingOvertimeConfig, data: overtimeRate } = useQuery(
    'getOvertimeRate',
    async () => {
      const { data } = await getOvertimeRate()
      let customData = data?.data?.categories
      return customData
    },
    {
      onError: (err) => Bugsnag.notify(err),
    }
  )
  let overtimeArr = new Array(3).fill('i')

  //number of days api
  const { data: numberOfDaysData, isLoading: loadingWorkdays } = useQuery(
    'numberOfWorkingDays',
    async () => {
      const { data } = await getNumDays()
      let numDays = data?.company_details
      return numDays
    },
    {
      onError: (err) => Bugsnag.notify(err),
    }
  )

  //excluded employees api
  const { data: excludedEmployees, loading: loadingExcludedEmployee } = useQuery(
    'getExcludedEmployees',
    async () => {
      const { data } = await retrieveExcludedEmployees()
      return data
    },
    {
      onError: (err) => {
        Bugsnag.notify(err)
      },
    }
  )

  // all employees
  const { data: allEmployees } = useQuery(
    'getAllAvailableEmployees',
    async () => {
      const { data } = await retrieveIncludedEmployees()
      return data
    },
    {
      onError: (err) => {
        Bugsnag.notify(err)
      },
    }
  )

  const [tabIndex, setTabIndex] = useState(0)
  const [newId, setNewId] = useState({ id: 0, item: 'Normal remuneration' })
  
  // Debug logging for newId changes
  useEffect(() => {
    console.log('newId state changed to:', newId)
  }, [newId])
  
  useEffect(() => {
    console.log('useEffect triggered, tabIndex:', tabIndex)
    changeTab(tabIndex)
  }, [tabIndex])
  const changeTab = (index) => {
    console.log('changeTab called with index:', index)
    switch (index) {
      case 0:
        setNewId({ id: 0, item: 'Normal remuneration' })
        break
      case 1:
        setNewId({ id: 1, item: 'Additional remuneration' })
        break
      case 2:
        setNewId({ id: 3, item: 'Benefit-In-Kind' })
        break
      case 3:
        setNewId({ id: 2, item: 'Value of Living Accomodation' })
        break
      case 4:
        setNewId({ id: 4, item: 'Deductions' })
        break
      default:
        break
    }
    console.log('newId set to:', { id: index === 0 ? 0 : index === 1 ? 1 : index === 2 ? 3 : index === 3 ? 2 : index === 4 ? 4 : 'unknown', item: index === 0 ? 'Normal remuneration' : index === 1 ? 'Additional remuneration' : index === 2 ? 'Benefit-In-Kind' : index === 3 ? 'Value of Living Accomodation' : index === 4 ? 'Deductions' : 'unknown' })
  }

  const handleOpen = () => {
    navigate('/app/management-centre/company-management/payroll/import-payroll', {
      state: {
        backgroundLocation: location,
      },
    })
  }

  return (
    <Box display="flex" width="100%" flexDirection="column" gap={2} px={{ xs: 2, lg: 0 }}>
      <Box>
        <Typography variant="h4" fontWeight="bold" mb={2}>
          General
        </Typography>
        <Box
          sx={{
            bgcolor: 'white.main',
            border: 1,
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
          }}
        >
          {/* hide payroll reminder */}
          {/* <Box
            display="flex"
            alignItems="center"
            padding={2}
            sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
          >
            <Typography color="light-gray-text.main" width={300}>
              Payroll reminder
            </Typography>
            {loadingWorkdays ? (
              <Typography variant="subtitle1" fontWeight="bold">
                <Skeleton width={200} />
              </Typography>
            ) : (
              <Typography variant="subtitle1" fontWeight="bold">
                {numberOfDaysData?.reminder_details !== null &&
                  `${numberOfDaysData?.reminder_details?.day} day of each month`}
              </Typography>
            )}
          </Box> */}
          <Box
            display="flex"
            alignItems="center"
            padding={2}
            sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
          >
            <Typography color="light-gray-text.main" width={300}>
              Total working days
            </Typography>
            {loadingWorkdays ? (
              <Typography variant="subtitle1" fontWeight="bold">
                <Skeleton width={200} />
              </Typography>
            ) : (
              <Typography variant="subtitle1" fontWeight="bold">
                {numberOfDaysData?.working_days_status === 2
                  ? `Total number of days in a month`
                  : numberOfDaysData?.working_days > 1
                  ? `${numberOfDaysData?.working_days} days per month`
                  : `${numberOfDaysData?.working_days} day per month`}
              </Typography>
            )}
          </Box>
          <ReminderModal numberOfDaysData={numberOfDaysData}>
            <Box sx={{ p: 0.5 }}>
              <AdxButton
                variant={'ghost'}
                sx={{ width: 1, display: 'flex', justifyContent: 'center' }}
              >
                Manage general settings
              </AdxButton>
            </Box>
          </ReminderModal>
        </Box>
      </Box>
      <Box>
        <Typography variant="h4" fontWeight="bold">
          Overtime
        </Typography>
        <Typography color="light-gray-text.main" mb={2}>
          Description: Manage overtime policy, which can be used during payroll adjustment.
          Applicable to all employees
        </Typography>
        <Box
          sx={{
            bgcolor: 'white.main',
            border: 1,
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
          }}
        >
          {loadingOvertimeConfig
            ? overtimeArr.map((item, index) => (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  padding={2}
                  key={index}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ width: 'calc(100% * 1 / 3)', mr: 2 }}
                  >
                    <Typography noWrap variant="subtitle1" mr={2}>
                      <Skeleton width={120} />
                    </Typography>
                  </Box>
                  <Box sx={{ width: 'calc(100% * 2 / 3)' }}>
                    <Skeleton width={200} />
                  </Box>
                </Box>
              ))
            : overtimeRate?.map((list, index) => {
                return (
                  <OvertimeList
                    details={list}
                    key={index}
                    sx={{
                      borderBottom: 1,
                      borderColor: 'gray-line.main',
                    }}
                  />
                )
              })}
          <Box>
            <OvertimeRateModal props={overtimeRate}>
              <Box sx={{ p: 0.5 }}>
                <AdxButton
                  variant={'ghost'}
                  sx={{ width: 1, display: 'flex', justifyContent: 'center' }}
                >
                  Manage overtime policy
                </AdxButton>
              </Box>
            </OvertimeRateModal>
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography variant="h4" fontWeight="bold">
          Payroll categories
        </Typography>
        <Typography color="light-gray-text.main" mb={2}>
          Description: Manage payroll categories, or create a new one.
        </Typography>
        <AdxTabsBadge
          sxTabs={{ py: 0, border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}
          setTabIndex={(index) => {
            console.log('AdxTabsBadge setTabIndex called with:', index)
            setTabIndex(index)
          }}
          scrollButtons={false}
        >
          <CustomCategoryTabPanel
            label="Normal remuneration"
            loading={loadCustomCategory}
            customList={customCategory}
            categoryIndex1={0}
            newId={newId}
            key={`normal-${newId.id}`}
          />
          <CustomCategoryTabPanel
            label="Additional remuneration"
            loading={loadCustomCategory}
            customList={customCategory}
            categoryIndex1={1}
            newId={newId}
            key={`additional-${newId.id}`}
          />
          <CustomCategoryTabPanel
            label="Benefit-In-Kind"
            loading={loadCustomCategory}
            customList={customCategory}
            categoryIndex1={3}
            newId={newId}
            key={`benefit-${newId.id}`}
          />
          <CustomCategoryTabPanel
            label="Value of Living Accomodation"
            loading={loadCustomCategory}
            customList={customCategory}
            categoryIndex1={2}
            newId={newId}
            key={`accommodation-${newId.id}`}
          />
          <CustomCategoryTabPanel
            label="Deductions"
            loading={loadCustomCategory}
            customList={customCategory}
            categoryIndex1={4}
            categoryIndex2={5}
            newId={newId}
            debugInfo={`Deductions tab - newId: ${JSON.stringify(newId)}`}
            key={`deductions-${newId.id}`}
          />
        </AdxTabsBadge>
      </Box>
      <PayslipThemeSetting />
      <ConnectedModules />
      <Box>
        <Typography variant="h4" fontWeight="bold">
          Import External Data
        </Typography>
        <Typography color="light-gray-text.main" mb={2}>
          Import staff payroll details via CSV file
        </Typography>
        <Card
          variant="outlined"
          sx={{
            mb: 3,
            boxSizing: 'border-box',
            borderRadius: '4.5px',
          }}
        >
          <Box
            sx={{
              width: '100%',
              p: 2,
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },

              alignItems: { xs: 'flex-start', sm: 'center' },
              boxSizing: 'border-box',
            }}
          >
            <Box
              display={'flex'}
              flexDirection={{ xs: 'column', sm: 'row' }}
              rowGap={1}
              alignItems={'center'}
              sx={{
                width: 1,
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: { xs: 1, sm: 3 / 4 },
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    marginRight: 2,
                    minWidth: 60,
                    height: 60,
                    borderRadius: 50,
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: 'alternate.light',
                    color: 'alternate.main',
                  }}
                >
                  <Icon
                    sx={{
                      fontSize: 35,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <InsertDriveFile />
                  </Icon>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Typography noWrap variant="h4">
                    Staff payroll details
                  </Typography>
                  <Typography variant="body1" color="light-gray-text.main">
                    Download the CSV file and fill in the details to get started with importing
                    employee details.
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  width: { xs: 1, sm: 1 / 4 },
                  display: 'flex',
                  justifyContent: { xs: 'center', sm: 'flex-end' },
                }}
              >
                <AdxButton sx={{ width: '80%' }} onClick={handleOpen}>
                  Import
                </AdxButton>
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box>
        <Typography variant="h4" fontWeight="bold">
          Excluded employee
        </Typography>
        <Typography color="light-gray-text.main" mb={2}>
          Description: Select employee who you want to permanently exclude from every payroll run
        </Typography>
        <Box
          sx={{
            bgcolor: 'white.main',
            border: 1,
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
          }}
        >
          {excludedEmployees?.length === 0 && !loadingExcludedEmployee ? (
            <Box sx={{ p: 2 }}>
              <Typography color="light-gray-text.main">
                No excluded employee yet. Click the add button below to exclude an employee
              </Typography>
            </Box>
          ) : (
            excludedEmployees?.map((list, index) => {
              return (
                <ExcludedEmployeeList
                  data={list}
                  key={index}
                  sx={{
                    borderBottom: excludedEmployees?.length - 1 === index ? 0 : 1,
                    borderColor: 'gray-line.main',
                  }}
                />
              )
            })
          )}
          <Box sx={{ borderTop: 1, borderColor: 'gray-line.main' }}>
            <ExcludedEmployeeModal employees={allEmployees}>
              <Box sx={{}}>
                <AdxButton
                  variant={'ghost'}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  startIcon={<Add />}
                >
                  Add new
                </AdxButton>
              </Box>
            </ExcludedEmployeeModal>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PayrollConfiguration
